import Component from "../../lib/component";
import {Wave} from "./wave";
import {WaveContainer} from "./wave_container";
import {injectStylesheet} from "../../helpers/injection";

export const WavesboxConfig = {
    componentTypeKey: 'Wavesbox',
    baseHtmlClass: 'wavesbox',
    selector: '.wavesbox',

    datasetConfigKey: 'wavesbox',

    defaultIsBlended: true,
};

export class Wavesbox extends Component {

    static get config() {
        return WavesboxConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: Wavesbox.config
        });

        this.setDatasetConfig(Wavesbox.config.datasetConfigKey);
        this.styleSheetPath = this.getDatasetConfigValue('stylesheet_path');
        this.count = this.getDatasetConfigValue('count') ?? 3;
        this.color = this.getDatasetConfigValue('color');
        this.isBlended = this.getDatasetConfigValue('blended') ?? Wavesbox.config.defaultIsBlended;

        this.waveContainer = getWaveContainer(this);
        this.waves = getWaves(this);

        // Render the initial state after we load any style sheets…
        if (this.styleSheetPath) {
            injectStylesheet(this.styleSheetPath, () => {
                this.renderInitial();
                this.render();
            });
        } else {
            this.renderInitial();
            this.render();
        }
    }

    renderInitial() {
        if (this.color) this.element.style.color = this.color;
        this.element.style.display = 'revert';
    }

    render() {
        this.waveContainer.render();
        this.waves.forEach((wave) => wave.render());
    }

}

function getWaveContainer(wavesbox) {
    let element = wavesbox.element.querySelector(WaveContainer.config.selector);
    if (!element) element = WaveContainer.createWaveContainerElement(wavesbox.element);
    return new WaveContainer(element, wavesbox);
}

function getWaves(wavesbox) {
    const elements = Array.from(wavesbox.element.querySelectorAll(Wave.config.selector));
    if (elements.length < wavesbox.count) {
        for (let i = elements.length; i < wavesbox.count; i++) {
            elements.push(Wave.createWaveElement(wavesbox.waveContainer.element));
        }
    }
    return elements.map((element) => {
        return new Wave(element, wavesbox)
    });
}